import { render, staticRenderFns } from "./order-summary.vue?vue&type=template&id=cd22e424&scoped=true&"
import script from "./order-summary.component.ts?vue&type=script&lang=ts&"
export * from "./order-summary.component.ts?vue&type=script&lang=ts&"
import style0 from "./order-summary.scss?vue&type=style&index=0&id=cd22e424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd22e424",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd22e424')) {
      api.createRecord('cd22e424', component.options)
    } else {
      api.reload('cd22e424', component.options)
    }
    module.hot.accept("./order-summary.vue?vue&type=template&id=cd22e424&scoped=true&", function () {
      api.rerender('cd22e424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-v2/components/order-summary/order-summary.vue"
export default component.exports